import { render, staticRenderFns } from "./ChangeList.vue?vue&type=template&id=3f84b855&scoped=true&"
import script from "./ChangeList.vue?vue&type=script&lang=js&"
export * from "./ChangeList.vue?vue&type=script&lang=js&"
import style0 from "./ChangeList.vue?vue&type=style&index=0&id=3f84b855&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84b855",
  null
  
)

export default component.exports